import { useAuth0Context } from "@/context/Auth0Context";
import { identifyUser } from "@/lib/events/mixpanel";
import { useEffect } from "react";
import { useMe } from "./useMe";

//  Hook to automatically identify users in Mixpanel when they're authenticated

export const useMixpanelIdentify = () => {
  const { user } = useAuth0Context();
  const { data: dbUser } = useMe();

  useEffect(() => {
    if (dbUser?.id && user?.email) {
      identifyUser(dbUser.id, {
        $name: user.name || dbUser.email || "",
        $email: user.email,
        title: dbUser.title || "",
        profession: dbUser.title || "",
        organizationId: dbUser.organization_id || "",
      });
    }
  }, [dbUser?.id, user?.email, user?.name, dbUser]);
};
